
(function () {
  function trackProductClick(event) {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest(
      'product-card a[href*="/products/"]'
    );

    if (!link) return;

    const card = link.closest('product-card');

    const productHandle =
      card?.getAttribute('handle') ||
      link.pathname?.split('/products/')[1]?.split('/')[0] ||
      new URL(link.href).pathname.split('/products/')[1]?.split('/')[0];

    if (!productHandle) return;

    const collectionMatch = window.location.pathname.match(
      /\/collections\/([^/]+)/
    );

    const collection = collectionMatch
      ? collectionMatch[1]
      : 'other';

    const clickData = {
      product_handle: productHandle,
      collection_handle: collection,
      click_source: link.classList.contains('product-card__media')
        ? 'image'
        : 'product_link'
    };

    // Respecteer Shopify Analytics-toestemming.
    const analyticsAllowed =
      window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();

    if (analyticsAllowed !== true) return;

    // Stuur naar Shopify.
    if (window.Shopify?.analytics?.publish) {
      Shopify.analytics.publish(
        'viva_product_click_test',
        clickData
      );
    }

    // Stuur uitsluitend de productklik naar GA4.
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'select_item', {
  send_to: 'G-S41LMVX1WQ',
  debug_mode: true,
        item_list_id: collection,
        item_list_name: collection,
        items: [{
          item_id: productHandle,
          item_name: productHandle,
          item_list_id: collection,
          item_list_name: collection
        }]
      });
    }
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    trackProductClick(event);
  }, true);

  // Ook toegankelijk voor toetsenbordgebruikers.
  document.addEventListener('click', function (event) {
    if (event.detail === 0) {
      trackProductClick(event);
    }
  }, true);
})();
